//import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Link } from 'react-router-dom'
import React from 'react'
import { useStyles } from './styles'
//import { WidgetLinkType } from 'data/Show'
//import SocialLinkIcons from 'data/SocialLinkIcons'
//import { SOCIAL_URL } from 'constants.js'
//import clsx from 'clsx'
import logoWhite from 'assets/novel-logo.svg'

/*
We're commenting these links out because we're not gonna use them right now
but we plan to reuse them in the near future.
*/
/*
const socialLinks = [
    {
        title: 'Instagram',
        url: SOCIAL_URL.INSTAGRAM,
        icon: SocialLinkIcons[WidgetLinkType.INSTAGRAM],
    },
    {
        title: 'Facebook',
        url: SOCIAL_URL.FACEBOOK,
        icon: SocialLinkIcons[WidgetLinkType.FACEBOOK],
    },
    {
        title: 'Twitter',
        url: SOCIAL_URL.TWITTER,
        icon: SocialLinkIcons[WidgetLinkType.TWITTER],
    },
]
*/

const Footer: React.FC = () => {
    const classes = useStyles()
    return (
        <footer className={classes.footer}>
            <div className={classes.container}>
                <div className={classes.title}>
                    <img className={classes.logo} src={logoWhite} alt="Logo" />
                </div>

                <div className={classes.content}>
                    {/* <div className={clsx(classes.social, classes.section)}>
                        <p className={classes.text}>Follow Us</p>

                        <nav className={classes.links}>
                            {socialLinks.map((link, index) => (
                                <a href={link.url} key={index} target="_blank" rel="noopener noreferrer">
                                    <FontAwesomeIcon className={classes.icon} icon={link.icon} />
                                    {link.title}
                                </a>
                            ))}
                        </nav>
                    </div> */}

                    <div className={classes.contact}>
                        <div className={classes.section}>
                            <a
                                className={classes.text}
                                href="mailto:info@benovel.com"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Get In Touch
                            </a>
                            <a
                                className={classes.text}
                                href="https://benovel.com/docs/privacy-policy.pdf"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Privacy Policy
                            </a>
                        </div>

                        <div className={classes.section}>
                            <a
                                className={classes.text}
                                href="https://benovel.com/docs/terms-of-use.pdf"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Terms of Use
                            </a>
                            <Link className={classes.text} to="/refund">
                                Refund Policy
                            </Link>
                        </div>

                        <div className={classes.section}>
                            <Link className={classes.text} to="/support">
                                Support
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    )
}

export default Footer
